import { render } from "./create_proba.html?vue&type=template&id=7b0a4de9&external"
import script from "./create_proba.js?vue&type=script&lang=js&external"
export * from "./create_proba.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__